import { Code } from '@atlaskit/code';
import { Stack } from '@atlaskit/primitives';
import { TokenExplorer } from '@af/design-system-docs-ui';
import * as React from 'react';
export default {
  Code,
  Stack,
  TokenExplorer,
  React
};